import memoize from 'js/lib/memoize';

import { memoizedCatalogData } from 'bundles/catalogP/api/api.promise';
import catalogUrl from 'bundles/catalogP/lib/catalogUrl';
import S12nMembership from 'bundles/catalogP/models/s12nMembership';

const s12nMembershipData = function (options: $TSFixMe) {
  return memoizedCatalogData(catalogUrl.build(S12nMembership.prototype.resourceName, options));
};

export default s12nMembershipData;
export const memoizedS12nMembershipData = memoize(s12nMembershipData);
